<!-- <div class="exc404">
  <div class="mainbox">
    <div class="err">{{ numberLeft }}</div>
    <i class="far fa-question-circle fa-spin"></i>
    <div class="err2">{{ numberRight }}</div>
    <div class="msg">{{ description }}&nbsp;<a (click)="routertoLogin()">Đăng nhập</a>.</div>

  </div>
</div> -->
<ng-container *ngIf="id == '404'">
  <img style="max-width: 850px; max-height: 500px; margin: auto;" src="../../../../assets/img/404_img.png">
  <div class="title-error">
    Không tìm thấy trang! <a (click)="routertoLogin()">Quay lại.</a>
  </div>
</ng-container>
<ng-container *ngIf="id == '401'">
  <img style="max-width: 850px; max-height: 500px; margin: auto; margin-top: 50px;margin-bottom: 50px;" src="https://gw.alipayobjects.com/zos/rmsportal/wZcnGqRDyhPOEYFcZDnb.svg">
  <div class="title-error">
    <div>401</div>
    Tài khoản không được ủy quyền vui lòng <a (click)="routertoLogin()"> đăng nhập lại.</a>
  </div>
</ng-container>
<ng-container *ngIf="id == 'timeout'">
  <img style="max-width: 850px; max-height: 500px; margin: auto; margin-top: 50px;margin-bottom: 50px;" src="https://gw.alipayobjects.com/zos/rmsportal/RVRUAYdCGeYNBWoKiIwB.svg">
  <div class="title-error">
    <div>500</div>
    Hết phiên đăng nhập vui lòng <a (click)="routertoLogin()">đăng nhập lại.</a>
  </div>
</ng-container>
